import { Entity } from 'src/commons/constants/entities';

export function makePaginateQueryKey(entity: Entity) {
  return `getInfinite${entity}key`;
}
